<template>
  <div class="progress">
    <div
      class="progress-bar"
      :style="{
        width: `${progress}%`
      }"
    >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    resetProgressBar: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timer: null,
      currentProgress: 0,
      step: 0.15,
      progress: 0,
    }
  },
  watch: {
    resetProgressBar() {
      // fully reset progress bar and start it again
      clearInterval(this.timer)
      this.currentProgress = 0
      this.handleTimer()
    },
  },
  mounted() {
    this.$nextTick(function _() {
      this.handleTimer()
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    handleTimer() {
      this.timer = setInterval(() => {
        this.currentProgress += this.step
        this.progress = Math.round(
          (Math.atan(this.currentProgress) / (Math.PI / 2)) * 100 * 1000,
        ) / 1000

        if (this.progress >= 99) {
          clearInterval(this.timer)
        } else if (this.progress >= 70) {
          this.step = 0.05
        } else if (this.progress >= 50) {
          this.step = 0.1
        }
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.progress {
  position: relative;
  width: 256px;
  height: 8px;
  background-color: #D3E6FD;
  border-radius: 90px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  border-radius: 90px;
  background-color: #6A1EBB;
  transition: 0.1s width linear;
}
</style>
